<template>
  <div>
    <!-- Toolbar -->
    <div class="toolbar d-flex flex-wrap justify-content-center justify-content-md-between mb-2">
      <div class="d-flex">
      </div>

      <div class="d-flex flex-wrap justify-content-center justify-content-md-start">
        <router-link :to="{ name: 'Seller-Bill-Create' }"
                     class="btn btn-success btn-sm">
          <i class="fal fa-plus-circle mr-1"></i>
          สร้างรายการจัดส่งใหม่
        </router-link>
      </div>
    </div>

    <!-- tab -->
    <div class="bill-status-list">
      <Tabs v-if="billCounts"
            id="bill-list-tabs"
            class="is-primary"
            :tabs="billCounts"
            :tabClasses="[
                  'warning',
                  'success',
                  'danger'
                ]"
            @tabSelected="handleTabChange"
            :active_tab_index="activetabIndex" />
    </div>

    <slot name="top"></slot>

    <div v-if="paginatedBills && !loading">
      <div v-if="paginatedBills.length"
           class="table-responsive">
        <table class="table _datatable bills-table --very-small-height">
          <thead>
            <tr>
              <th>หมายเลขบิล</th>
              <th>วันที่</th>
              <th>สถานะ</th>
              <th>ลูกค้า</th>
              <th>จำนวนพัสดุ</th>
              <th></th>
            </tr>
          </thead>
          <tbody :class="{ '--loading': miniLoading }">
            <tr v-for="(row, index) in computedBillsList"
                :key="index">
              <td v-html="tdHtml('billNo', row.billNo)"></td>
              <td v-html="tdHtml('createdAtDate', row.createdAt)"></td>

              <td v-html="tdHtml('status', row.status)"
                  class="--width-md"></td>

              <td>
                <span v-if="row.shipperName === 'N/A'">{{ row.shipperName }}</span>
                <router-link v-else
                             :to="{ name: 'Seller-Shippers', query: { shipperId: row.shipperId } }"
                             class="btn btn-link btn-sm text-color-5">
                  {{ row.shipperName }}
                </router-link>
                
              </td>

              <td class="--width-md">
                {{ row.orders ? row.orders.length : 0 }}
              </td>

              <td>
                <router-link v-if="[1].includes(row.status)"
                             :to="{ name: 'Seller-Bill-Create', query: { billNo: `${row.billNo}__${row.createdAt}` } }"
                             class="btn btn-link btn-sm text-color-5">
                  <i class="fal fa-edit"></i>
                </router-link>

                <Button variant="link"
                        v-if="[1].includes(row.status)"
                        custom_class="p-0 text-color-5 mr-2"
                        size="sm"
                        id="btn-action-delete"
                        @click="deleteItem(`${row.billNo}__${row.createdAt}`)">
                  <i class="fal fa-times-circle"></i>
                </Button>


                <router-link v-if="[2, 3].includes(row.status)"
                             :to="{ name: 'Seller-Bill-Show', params: { billNo: `${row.billNo}__${row.createdAt}` } }"
                             class="btn btn-link btn-sm text-color-5">
                  <i class="fal fa-eye"></i>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="d-flex justify-content-between">
          <div>
            <select class="form-control"
                    v-model="perPage"
                    @change="handlePerPageChange()">
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="300">300</option>
              <option value="500">500</option>
            </select>
          </div>

          <div class="d-flex">
            <p class="align-self-center mr-2 text-color-4">
              หน้าที่ {{ page }}
            </p>

            <div class="btn-group"
                 role="group">
              <Button type="button"
                      variant="outline-primary"
                      size="lg"
                      id="btn-paginate-prev"
                      @click="paginate(false)"
                      :disabled="page === 1">
                <i class="fal fa-long-arrow-left"></i>
              </Button>

              <Button type="button"
                      variant="outline-primary"
                      size="lg"
                      id="btn-paginate-prev"
                      @click="paginate(true)"
                      :disabled="page === lastPage"
                      :loading="miniLoading">
                <i class="fal fa-long-arrow-right"></i>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="!paginatedBills.length && search.keyword">
        <div class="alert alert-warning">
          No Bills found
        </div>
      </div>
    </div>

    <div v-else>
      <Spinner :variant="'primary'"
               size="md" />
    </div>

    <!-- Mass Cancel Modal -->
    <Modal id="mass-cancel-modal"
           custom_dialog_class="modal-dialog-centered">
      <template slot="body">
        <div>
          <p class="lead text-center mb-3">
            {{ $t("mass_cancel.cancel_bill") }}
          </p>

          <p class="text-color-4 text-center"
             v-if="massCancel.loading">
            {{ $t("mass_cancel.prosessing_msg_p1") }}
            {{ massCancel.total - massCancel.remaining + 1 }} /
            {{ massCancel.total }}
          </p>
          <p class="text-color-4 text-center"
             v-else>
            {{ $t("mass_cancel.confirm_msg_p1") }} {{ selectedBills.length }}
            {{ $t("mass_cancel.confirm_msg_p2") }} ?
          </p>

          <div class="d-flex justify-content-center mt-4">
            <button type="button"
                    class="btn btn-secondary btn-sm mr-2"
                    data-dismiss="modal">
              {{ $t("general.no") }}
            </button>

            <Button id="btn-mass-cancel"
                    variant="primary"
                    size="sm"
                    @click="handleMassCancel()"
                    :loading="massCancel.loading"
                    :disabled="massCancel.loading">
              {{ $t("general.yes") }}
            </Button>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import TextBox from "@/components/core/TextBox";
import NumberField from "@/components/core/TextBox";
import Modal from "@/components/core/Modal";
import Button from "@/components/core/Button";
import { Alert } from "@/helpers/alert";
import Spinner from "@/components/core/Spinner";
import Tabs from "@/components/core/Tabs";
import CopyButton from "@/components/derived/CopyButton";
import _ from "lodash";
import { mapGetters } from "vuex";
import { getBillStatus } from "@/helpers/core";
import { i18n } from "@/i18n";
import Select from "@/components/core/Select";
import { FILTERS } from "@/helpers/filters";

export default {
  name: "BillsTable",
  components: {
    TextBox,
    NumberField,
    Modal,
    Button,
    Spinner,
    Tabs,
    Select,
    CopyButton,
  },
  data() {
    return {
      billRows: null,
      billCounts: null,
      LastEvaluatedKey: null,
      paginatedBills: null,

      loading: false,
      miniLoading: false,
      modalLoading: false,

      massCancel: {
        loading: false,
        total: 0,
        remaining: 0,
      },

      selectedBills: [],
      selectedStatus: 1,

      page: 1,
      perPage: 100,
      lastPage: null,
      selectAllStatus: false,
      currentTabStatus: 0,

      shippers: null,
      shopsApiData: null,
      selectedShop: null,
      sampleFileLink: null,
      shippingMethods: null,
      selectedShippingMethod: null,
      hasBoxSizes: false,

      codFilterForm: { min: null, max: null },

      // filter by shop
      billShops: null,
      selectedBillshop: null,
      sortByProducts: false,

      search: {
        column: "trackingNo",
        keyword: null,
      },
    };
  },

  created() {
    this.billCounts = [
      { label: "ยังไม่ชำระ", value: 1 },
      { label: "ชำระแล้ว", value: 2 },
      { label: "ยกเลิก", value: 3 },
    ];

    this.currentTabStatus = localStorage.getItem("currentBillTabStatus");
  },

  mounted() {
  },

  methods: {
    tdHtml(type, value) {
      const types = {
        status: (value) => {
          let statusData = getBillStatus(value);
          if (!statusData) return value;
          return `<span class="badge badge-pill text-uppercase status-badge --${statusData.variation}">${statusData.title}</span>`;
        },
        shipperId: (value) => {
          return `<a href="/shippers/${value}"> ${value}</a>`
        },

        createdAtDate: (value) => {
          return FILTERS.formatDate(value);
        },

        createdAtTime: (value) => {
          return FILTERS.formatTime(value);
        },

        ellipsis: (value) => {
          return FILTERS.ellipsis(value, 15);
        },
      };
      return types[type] ? types[type](value) : value;
    },

    paginate(forward = true) {
      if (forward) {
        if (!(this.lastPage && this.page === this.lastPage))
          this.page = this.page + 1;
      } else {
        this.page = Math.max(--this.page, 1);
      }
      this.handlePageChange();
    },

    fetchBills(value, firstPage = true, _callback) {
      if (firstPage) this.loading = true;
      else this.miniLoading = true;

      this.$store.dispatch("bills/fetchBills", {
        status: value,
        LastEvaluatedKey: !firstPage
          ? JSON.stringify(this.LastEvaluatedKey)
          : null,
        perPage: this.perPage,
        callback: (status, data) => {
          if (status) {
            this.LastEvaluatedKey = data.LastEvaluatedKey;

            if (firstPage) {
              this.billRows = data.bills;
              this.page = 1;
              this.lastPage = null;
            } else {
              this.billRows = this.billRows.concat(data.bills);
            }

            this.billCounts = [
              {
                label: "ยังไม่ชำระ",
                number: data.billCounts[1],
                value: 1,
              },
              {
                label: "ชำระแล้ว",
                number: data.billCounts[2],
                value: 2,
              },

              {
                label: "ยกเลิก",
                number: data.billCounts[3],
                value: 3,
              },
            ];

            // LOGIC: check from counter
            this.lastPage =
              data.bills.length < data.billCounts[this.currentTabStatus]
                ? null
                : Math.ceil(this.billRows.length / this.perPage);

            this.handlePageChange();
          }

          if (firstPage) this.

            loading = false;
          else this.miniLoading = false;

          if (_callback) _callback();
        },
      });
    },

    searchBills() {
      let searchData = {
        ...this.search,
        status: this.currentTabStatus
      };
      this.loading = true;
      this.$store.dispatch("bills/searchBills", {
        ...searchData,
        callback: (status, data) => {
          this.billRows = data.results.map((d) => {
            return {
              id: d.id,
              trackingNo: d.trackingNo,
              status: d.status,
              shippingMethod: d.shippingMethod,
              billCode: d.billCode,
              custName: d.customerName,
              custPhone: d.phoneNo,
              createdAt: d.createdAt,
              codAmount: d.codAmount,
              shopName: d.shopName,
              codPaid: d.codPaid,
              printed: d.printCount && d.printCount > 0,
            };
          });
          this.page = 1;
          this.lastPage = null;
          this.LastEvaluatedKey = null;
          this.handlePageChange();
          this.loading = false;
        },
      });
    },

    handlePageChange() {
      let startIndex = (this.page - 1) * this.perPage;
      let endIndex = this.perPage * this.page - 1;

      // check if it needs data to load from server
      if (
        this.billRows.length <= endIndex &&
        this.LastEvaluatedKey &&
        this.page != this.lastPage
      ) {
        this.fetchBills(this.currentTabStatus, false, () => {
          this.paginatedBills = this.billRows.slice(startIndex, endIndex + 1);
        });
      } else {
        this.paginatedBills = this.billRows.slice(startIndex, endIndex + 1);
      }

      //handle empty page
      if (this.paginatedBills.length === 0) {
        this.page--;
        this.lastPage = this.page;
        this.handlePageChange();
        this.LastEvaluatedKey = null;
      }
      this.selectAllStatus = false;
      this.selectedBills = [];
    },

    handlePerPageChange() {
      this.page = 1;
      this.handlePageChange();
    },

    toggleSelect(bill, manual = false) {
      let checkboxElem = this.$refs["bill-checkbox-" + bill.billNo][0];
      if (!checkboxElem) return;
      if (manual) checkboxElem.checked = !checkboxElem.checked;
      let tableRow = checkboxElem.parentElement.parentElement;
      if (!tableRow) return;
      if (!checkboxElem.checked) {
        checkboxElem.checked = true;
        tableRow.classList.add("--selected");
        this.selectedBills.push({
          billNo: bill.billNo,
          status: bill.status,
          createdAt: bill.createdAt,
          orders: bill.orders,
        });
      } else {
        let index = this.selectedBills.findIndex((a) => a.billNo === bill.billNo);
        this.selectedBills.splice(index, 1);
        checkboxElem.checked = false;
        tableRow.classList.remove("--selected");
      }
    },

    handleTabChange(value) {
      this.currentTabStatus = value;
      localStorage.setItem("currentBillTabStatus", value);
      this.LastEvaluatedKey = null;

      this.fetchBills(value, true, () => {
        this.selectedBills = [];
      });
    },

    goto(type, id, newTab = false) {
      let routerData;

      if (type === "Show")
        routerData = { name: this.detail_path_name, params: { id } };
      else if (type === "Edit")
        routerData = { name: this.edit_path_name, params: { id } };

      if (newTab) window.open(this.$router.resolve(routerData).href, "_blank");
      else this.$router.push(routerData);
    },

    deleteItem(billNo) {
      Alert(
        i18n.t("general.cancel"),
        i18n.t("alert.cancel.message"),
        null,
        async () => {
          this.miniLoading = true;
          const { status } = await this.$store.dispatch("bills/cancelBill", { billNo })
          if (status) {
            let index = this.paginatedBills.findIndex(b => b.billNo === billNo.split("__")[0])
            if (index !== -1) {
              this.paginatedBills.splice(index, 1)
              this.billCounts[this.currentTabStatus - 1].number--;
              this.billCounts[2].number++;
            }
          }

          this.miniLoading = false;
        }
      );
    },

    async handleMassCancel() {
      if (!this.selectedBills.length) return;

      this.massCancel.total = this.selectedBills.length;
      this.massCancel.remaining = this.selectedBills.length;
      this.massCancel.loading = true;

      for (let i = 0; i < this.selectedBills.length; i++) {
        // const billId = this.selectedBills[i].id;
        // try {
        //   await http.delete(
        //     "https://pkp9f3293d.execute-api.ap-southeast-1.amazonaws.com/dev/v1/bills/" +
        //     billId
        //   );
        // } catch (e) {
        //   console.log(e);
        // }
        // this.massCancel.remaining--;

        // if (this.massCancel.remaining === 0) {
        //   this.massCancel = {
        //     loading: false,
        //     total: 0,
        //     remaining: 0,
        //   };
        //   this.selectedBills = [];
        //   $("#mass-cancel-modal").modal("hide");
        //   this.handleTabChange(this.currentTabStatus);
        // }
      }
    },

    cancelModal(id) {
      $("#" + id).modal("hide");
    },

    openModal(id) {
      $("#" + id).modal("show");
    }
  },

  computed: {
    ...mapGetters("bills", ["activeStatus"]),
    ...mapGetters("user", ["authData"]),

    username() {
      if (this.authData && this.authData.user && this.authData.user.username)
        return this.authData.user.username;
      return false;
    },

    buttonClass() {
      return `btn btn-sm btn-outline-primary mr-2`;
    },

    selectedBillsDict() {
      if (this.selectedBills && this.selectedBills.length) {
        let _selectedBills = this.selectedBills.filter((o) => o.status == 1);

        let obj = {};
        _selectedBills.forEach((ord) => {
          let status =
            getBillStatus(ord.status).title +
            " to " +
            (ord.status == 1
              ? getBillStatus(2).title
              : getBillStatus(1).title);
          if (obj[status]) obj[status].count++;
          else obj[status] = { count: 1 };
        });
        return obj;
      }
    },

    activetabIndex() {
      return this.currentTabStatus ? parseInt(this.currentTabStatus) : 0;
    },

    showSelectAll() {
      return (
        (this.currentTabStatus && this.currentTabStatus === 1) ||
        this.currentTabStatus === 2 || this.currentTabStatus === -1
      );
    },

    computedBillsList() {
      // if (!this.selectedBillshop) return this.paginatedBills;
      let bills = this.paginatedBills;

      if (this.selectedBillshop)
        bills = bills.filter((o) => o.shopId == this.selectedBillshop);

      let min = parseFloat(this.codFilterForm.min) || 0;
      let max = parseFloat(this.codFilterForm.max) || Infinity;
      return bills.filter((o) =>
        (o.codAmount && !isNaN(o.codAmount)) ? o.codAmount >= min && o.codAmount <= max : true
      );
    },
  }
};
</script>

<style lang="scss"
       scoped></style>